import { isEmpty, VFlow } from 'bold-ui'
import { TipoAcompanhamentoEnum } from 'graphql/types.generated'
import React from 'react'

import { AccordionCardSection } from '../../soap/aside/components/AccordionCardSection'
import { AcompanhamentoCard } from './AcompanhamentoCard'

interface AcompanhamentoAccordionCardProps<T> {
  id: string
  title: string
  itemName: string
  tipoAcompanhamento: TipoAcompanhamentoEnum
  placeholder?: string
  bodyPadding?: string
  loading?: boolean
  items?: T[]
  accordionItems?: T[]
  renderRow?: (index: number, item: T) => React.ReactNode
}

export function AcompanhamentoAccordionCard<T>(props: Readonly<AcompanhamentoAccordionCardProps<T>>) {
  const {
    id,
    title,
    itemName,
    tipoAcompanhamento,
    placeholder,
    bodyPadding = '0',
    loading = false,
    items,
    accordionItems,
    renderRow,
  } = props
  const hasItems = !isEmpty(items)

  return (
    <AcompanhamentoCard
      id={id}
      title={title}
      tipoAcompanhamento={tipoAcompanhamento}
      placeholder={placeholder}
      bodyPadding={hasItems ? bodyPadding : undefined}
      loading={loading}
    >
      {hasItems && (
        <VFlow vSpacing={0}>
          {items.map((item, index) => renderRow(index, item))}

          {!isEmpty(accordionItems) && (
            <AccordionCardSection
              id={id}
              contentPadding='0'
              title={{
                closed: `Mostrar +${itemName.pluralizeAndConcatValue(accordionItems.length)}`,
                open: `Esconder ${itemName}${accordionItems.length > 1 ? 's' : ''}`,
              }}
            >
              {accordionItems.map((item, index) => renderRow(index, item))}
            </AccordionCardSection>
          )}
        </VFlow>
      )}
    </AcompanhamentoCard>
  )
}
